module.exports = __webpack_public_path__ + "img/tooth6.895ceabf.png";